import { render, staticRenderFns } from "./bxbk.vue?vue&type=template&id=027a8aee&scoped=true"
import script from "./bxbk.vue?vue&type=script&lang=js"
export * from "./bxbk.vue?vue&type=script&lang=js"
import style0 from "./bxbk.vue?vue&type=style&index=0&id=027a8aee&prod&scoped=true&lang=css"
import style1 from "./bxbk.vue?vue&type=style&index=1&id=027a8aee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027a8aee",
  null
  
)

export default component.exports